<template>
  <MultiLevelNavigationModal
    v-model="localValue"
    :modal-title="$t('selectMediaAssetValue')"
    :fetch-branches="getNoBranches"
    :fetch-leaves="getMediaAssetValues"
    :selectable-type="['leaf']"
    :selected-entry-id="selectedEntryId"
    :base-path-title="$t('media.assets')"
    with-all
    @confirm="onConfirm"
    @hide="emits('hide')"
    @cancel="emits('cancel')"
    @close="emits('close')" />
</template>

<script setup lang="ts">
import { useContentLanguages } from "@common/composable/useMetaDataStore";

import { AttributeDataType } from "@medapro-types/common/common-enum";
import { Branch, Leaf, MultiLevelNavigationConfirmModel } from "@medapro-types/common/components/MultiLevelNavigation";
import { ArticleMediaAssets } from "@medapro-types/ContentEditor/content-editor-store";

import mediaAssetsApi from "@services/mediaAssets.js";

import { computed } from "vue";

import MultiLevelNavigationModal from "./MultiLevelNavigationModal.vue";

//#region General
const emits = defineEmits(["confirm", "cancel", "close", "input", "hide"]);

const props = defineProps<{ value: boolean; selectedEntryId: string | null | undefined }>();
//#endregion

//#region Store
const { primaryLanguageCode } = useContentLanguages();
//#endregion

const onConfirm = (event: MultiLevelNavigationConfirmModel) => {
  emits("confirm", event);
};

//#region localValue
const localValue = computed({
  get: () => props.value,
  set: (nv) => emits("input", nv)
});

//#endregion

//#region FetchMethods
const getNoBranches = async (): Promise<Branch[]> => {
  return [];
};

const getMediaAssetValues = async (): Promise<Leaf[]> => {
  const fetched: Array<Record<string, ArticleMediaAssets>> = await mediaAssetsApi.get([primaryLanguageCode.value], "Article");

  return fetched.map((x) => ({
    id: x[primaryLanguageCode.value].mediaAssetId,
    name: x[primaryLanguageCode.value].mediaAssetName,
    dataType: AttributeDataType.AttributeDataTypeAlphanumerical,
    icon: "MediaAsset"
  }));
};
//#endregion
</script>
